document.addEventListener("DOMContentLoaded", function () {
    const gallery = document.querySelector('.product_gallery');

    function initOrDestroySlider() {
        const width = window.innerWidth;

        if (width <= 991) { 
            if (!gallery.classList.contains('slick-initialized')) {
                $('.product_gallery').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    arrows: false,
                    dots: false,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    speed: 1000,
                    infinite: true,
                    variableWidth: false
                });
            }
        } else { 
            if (gallery.classList.contains('slick-initialized')) {
                $('.product_gallery').slick('unslick');
            }
        }
    }

    initOrDestroySlider();

    window.addEventListener('resize', () => {
        initOrDestroySlider();
    });
});
